import { render, staticRenderFns } from "./CardCertificates.vue?vue&type=template&id=d48d2038&scoped=true&"
import script from "./CardCertificates.vue?vue&type=script&lang=js&"
export * from "./CardCertificates.vue?vue&type=script&lang=js&"
import style0 from "./CardCertificates.vue?vue&type=style&index=0&id=d48d2038&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d48d2038",
  null
  
)

export default component.exports